import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
import { PlusIcon, MinusIcon } from '../lib/icons';
const FAQS = [{
  q: '¿Cómo se accede?',
  a: 'El acceso es inmediato luego de completar la compra.'
}, {
  q: '¿La formación es online?',
  a: 'Sí. Todo el contenido es 100% digital.'
}, {
  q: '¿Incluye clases en vivo?',
  a: 'No. El material está diseñado para avanzar completamente a tu ritmo.'
}, {
  q: '¿Incluye certificado?',
  a: 'Sí. Incluye certificado digital editable.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'El acceso es ilimitado.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí. Contás con garantía de satisfacción de 7 días.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border border-[#2d3f2a]/10 rounded-xl bg-[#f9f4e8] overflow-hidden transition-all duration-300" data-id="element-130">
      <button onClick={onClick} className="w-full flex items-center justify-between p-5 text-left focus:outline-none hover:bg-[#faf3e3] transition-colors" data-id="element-131">
        <span className="text-[#1e3a1e] font-bold text-base md:text-lg pr-4" data-id="element-132">
          {q}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-[#2d3f2a] text-white' : 'bg-white border border-[#2d3f2a]/10 text-[#2d3f2a]'}`} data-id="element-133">
          {isOpen ? <MinusIcon size={18} data-id="element-134" /> : <PlusIcon size={18} data-id="element-135" />}
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-136">
        <div className="p-5 pt-0 text-[#3a4a35] text-sm md:text-base leading-relaxed border-t border-[#2d3f2a]/5 mt-2" data-id="element-137">
          {a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [ref, vis] = useReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#f9f4e8] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2d3f2a]/5" data-id="element-138">
      <div className="container mx-auto max-w-3xl" data-id="element-139">
        <div ref={ref} className={`reveal text-center mb-6 ${vis ? 'is-visible' : ''}`} data-id="element-140">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-[#1e3a1e]" data-id="element-141">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-142">
          {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-143" />)}
        </div>
      </div>
    </section>;
}